import { render, staticRenderFns } from "./sendSMS.vue?vue&type=template&id=5102ef1a&scoped=true&"
import script from "./sendSMS.vue?vue&type=script&lang=js&"
export * from "./sendSMS.vue?vue&type=script&lang=js&"
import style0 from "./sendSMS.vue?vue&type=style&index=0&id=5102ef1a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5102ef1a",
  null
  
)

export default component.exports